import { isofetch } from 'Services/Fetch'

export const cloudinaryWidget = async (options, done) => {
  const initial_options = {
    cloudName: process.env.NEXT_PUBLIC_CLOUDINARY_NAME,
    uploadPreset: 'default',
    showPoweredBy: false,
    sources: ['local', 'url', 'camera', 'dropbox', 'image_search', 'facebook', 'instagram', 'unsplash'],
    prepareUploadParams: (cb, params) => {
      params = [].concat(params) //params can be a single object or an array of objects
      Promise.all(
        params.map((req) =>
          isofetch('/api/cloudinary', 'POST', { params: req }).then((response) =>
            Object.assign(
              {
                signature: response.signature,
                api_key: response.api_key,
              },
              response.upload_params
            )
          )
        )
      )
        .then((results) => cb(results.length === 1 ? results[0] : results))
        .catch((error) => {
          console.log(error)
        })
    },
  }

  const cloudinary_options = { ...initial_options, ...options }

  const widget = !!window.cloudinary && window.cloudinary.createUploadWidget(cloudinary_options, done)
  widget.open()
}

export const cloudinaryUrlCropped = (url) => {
  if (url) {
    // https://res.cloudinary.com/beldenst/image/upload/b_rgb:000000,w_2500,ar_1.25,c_scale,e_blur:1000,o_70/l_titan:cncexpert:users:92053854:projects:1bCAD_bmicuz/fl_layer_apply,g_center/titan/cncexpert/users/92053854/projects/1bCAD_bmicuz.jpg
    const new_url = url.replace('image/upload/', 'image/upload/c_crop,g_custom/')

    return new_url
  } else {
    return ''
  }
}

export const cloudinaryPostUrl = (url) => {
  if (url) {
    // https://res.cloudinary.com/beldenst/image/upload/b_rgb:000000,w_2500,ar_1.25,c_scale,e_blur:1000,o_70/l_titan:cncexpert:users:92053854:projects:1bCAD_bmicuz/fl_layer_apply,g_center/titan/cncexpert/users/92053854/projects/1bCAD_bmicuz.jpg
    let new_url = url.replace('image/upload/', 'image/upload/c_crop,w_2500,q_85/')

    // force end of url to have .jpg even if it is .jpg, .jpeg, .png or any other file format
    new_url = new_url.replace(/\.[^/.]+$/, '.jpg')

    return new_url
  } else {
    return ''
  }
}

export const cloudinaryPostUrlThumbnail = (url) => {
  if (url) {
    // https://res.cloudinary.com/beldenst/image/upload/b_rgb:000000,w_2500,ar_1.25,c_scale,e_blur:1000,o_70/l_titan:cncexpert:users:92053854:projects:1bCAD_bmicuz/fl_layer_apply,g_center/titan/cncexpert/users/92053854/projects/1bCAD_bmicuz.jpg
    let new_url = url.replace('image/upload/', 'image/upload/c_crop,c_scale,w_1000,q_80/')

    // force end of url to have .jpg even if it is .jpg, .jpeg, .png or any other file format
    new_url = new_url.replace(/\.[^/.]+$/, '.jpg')

    return new_url
  } else {
    return ''
  }
}

export const cloudinaryDocUrlCropped = (url) => {
  if (url) {
    let new_url = url.replace('image/upload/', 'image/upload/c_fill,g_north,ar_1.28,w_800/')

    new_url = new_url.replace(/\.[^/.]+$/, '.png')

    return new_url
  } else {
    return ''
  }
}

export const cloudinaryAvatarUrlCropped = (url) => {
  if (url) {
    const new_url = url.replace('image/upload/', 'image/upload/c_crop,g_custom/')

    return new_url
  } else {
    return ''
  }
}

export const cloudinaryCertShareUrl = (url) => {
  if (url) {
    let new_url = url.replace('image/upload/', 'image/upload/b_black,c_pad,h_630,w_1200/')
    new_url = url.replace('.png', '.jpg')

    return new_url
  } else {
    return ''
  }
}

export const cloudinaryResize = (url, width) => {
  if (url) {
    let new_url = url.replace('image/upload/', `image/upload/c_fill,g_north,ar_1.28,w_${width}/`)

    return new_url
  } else {
    return ''
  }
}

export const uploadFiles = async ({ files, folder, preset, name, setValue }) => {
  const timestamp = Math.round(new Date().getTime() / 1000)

  const sign_response = await isofetch('/api/cloudinary', 'POST', {
    params: {
      folder: folder,
      tags: ['post'],
      upload_preset: preset,
      timestamp: timestamp,
    },
  })

  const formData = new FormData()

  const no_error_files = files.filter((file) => !file.has_error)

  let promises = no_error_files.map((file, index) => {
    formData.append('file', file.file)
    formData.append('api_key', sign_response.api_key)
    formData.append('timestamp', sign_response.timestamp)
    formData.append('signature', sign_response.signature)
    formData.append('folder', folder)
    formData.append('upload_preset', preset)
    formData.append('tags', ['post'])

    const api_url = 'https://api.cloudinary.com/v1_1/' + sign_response.cloudname + '/image/upload'

    const xhr = new XMLHttpRequest()

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100
        setValue(`${name}.${index}.progress`, percentComplete)
      }
    })

    const uploadPromise = new Promise((resolve, reject) => {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            const response = JSON.parse(xhr.responseText)
            resolve(response)
          } else {
            reject(new Error(`Upload failed for file ${file.file.name}`))
          }
        }
      }
    })

    xhr.open('POST', api_url, true)
    xhr.send(formData)

    return uploadPromise
  })

  const cloudinary_responses = await Promise.all(promises)
  console.log({ cloudinary_responses })
  const urls = cloudinary_responses.map((response, index) => {
    no_error_files[index].cloudinary_url = response.secure_url
    setValue(`photos.${index}.cloudinary_url`, response.secure_url)

    return response.secure_url
  })

  return no_error_files
}
